// extracted by mini-css-extract-plugin
module.exports = {"hovers":"hovers_hovers__2ZIbY"};